export const LANG = {
  login:{
    title_mesg:"HuaXia Chorus",
    email_label_mesg:"Email",
    password_label_mesg:"Password",
    f_password_label_mesg:"Forget Password?",
    login_button_mesg:"Sign In",
    not_account_laebl_mesg:"New User?",
    register_label_mesg:"Create An Account"
  },
  header_search:{
    placeholder_mesg:"Searching..."
  },
  header_user:{
    setting_mesg:"Settings",
    logout_mesg:"Logout"
  },
  sidebar_header:{
    logo_name_mesg:"UTB.COLUD",
    sidebar_collapse_mesg:"Collapsed Sidebar",
    sidebar_open_mesg:"Expand Sidebar"
  },

  leftSideBar_Menu:{
    my_share_item_mesg:"Share",
    my_ing_item_mesg:"Developing",
    my_on_item_mesg:"On Shelf",
    my_off_item_mesg:"Off Shelf",
    create_mesg:"新建装备",
  }
}
